import type {State} from 'src/reducers';
import type {
  Pages,
  Leads,
  Action,
  GenericError,
  Forms,
  SubDomainDetail,
  LeadsFilter,
  LeadsCreateFilterResponse,
  LeadForm,
  FilterViewCount,
  LeadFilterActionResponse,
  BeFreeJson,
} from 'src/types/landing-page';
import {LandingPageCurrentState} from 'src/reducers/landing-page';
import orderBy from 'lodash/orderBy';


export const selectLandingPages = (state: State): Pages[] | null | undefined =>
  state.landingPage.pages
    ? orderBy(state.landingPage.pages, ['updated_at'], ['desc'])
    : [];

export const selectLandingPagesDetail = (state: State): Pages =>
  // @ts-expect-error - TS2339 - Property 'pages_detail' does not exist on type 'LandingPageState'.
  state.landingPage.pages_detail;

export const selectIfFormsLoading = (state: State): boolean =>
  state?.landingPage?.current_state ===
  LandingPageCurrentState.LOADING_PAGES_FORMS;

export const selectLandingPagesLeads = (
  state: State,
): Leads[] | null | undefined => state.landingPage.leads;

export const selectLandingPagesLeadsLoading = (state: State): boolean =>
  state?.landingPage?.current_state ===
  LandingPageCurrentState.LOADING_PAGES_LEADS;

export const selectLandingPagesForms = (
  state: State,
): Forms[] | null | undefined =>
  state.landingPage.forms
    ? // @ts-expect-error - TS2339 - Property 'forms' does not exist on type 'LandingPageState'.
      orderBy(state.landingPage.forms, ['time_updated'], ['desc'])
    : [];

export const selectLandingPagesFormsLoading = (state: State): boolean => {
  return (
    state?.landingPage?.current_state ===
    LandingPageCurrentState.LOADING_PAGES_FORMS
  );
};

export const selectLandingPagesFormsDetail = (
  state: State,
): Pages[] | null | undefined =>
  // @ts-expect-error - TS2339 - Property 'formsDetail' does not exist on type 'LandingPageState'.
  state.landingPage.formsDetail;

export const selectLandingPagesFormsDetailLoading = (state: State): boolean =>
  state?.landingPage?.current_state ===
  LandingPageCurrentState.FETCHING_PAGES_FORMS_DETAIL;

export const selectPagesAction = (state: State): Action =>
  // @ts-expect-error - TS2339 - Property 'page_action' does not exist on type 'LandingPageState'.
  state.landingPage.page_action;

export const selectPagesActionLoading = (state: State): boolean =>
  state?.landingPage?.current_state ===
  LandingPageCurrentState.LOADING_PAGES_ACTION_DETAIL;

export const selectIfUrlCheckLoading = (state: State): boolean =>
  state?.landingPage?.current_state ===
  LandingPageCurrentState.CHECKING_URL_AVAILABILITY;

export const selectPagesActionError = (
  state: State,
): GenericError | null | undefined => state?.landingPage?.page_action_error;

export const selectFormError = (
  state: State,
): GenericError | null | undefined => state?.landingPage?.forms_error;
/*
 * Base Selectors
 */

export const selectLandingPage = (
  state: State,
): {
  [key: string]: string;
  // @ts-expect-error - TS2339 - Property 'page' does not exist on type 'LandingPageState'.
} => state.landingPage.page;

export const selectIfLandingPageLoading = (state: State): boolean =>
  state?.landingPage?.current_state ===
  LandingPageCurrentState.LOADING_PAGE_DETAIL;

export const selectLandingPageStep = (
  state: State,
): {
  [key: string]: string;
  // @ts-expect-error - TS2339 - Property 'step' does not exist on type 'LandingPageState'.
} => state.landingPage.step;

export const selectFormUpdate = (
  state: State,
): {
  [key: string]: string;
  // @ts-expect-error - TS2339 - Property 'update_form' does not exist on type 'LandingPageState'.
} => state.landingPage.update_form;

export const selectFormUpdateLoading = (state: State): boolean =>
  state?.landingPage?.current_state ===
  LandingPageCurrentState.LOADING_PAGE_UPDATE_FORM_ACTION;

export const selectFormUpdateError = (
  state: State,
): {
  [key: string]: string;
  // @ts-expect-error - TS2339 - Property 'update_form_error' does not exist on type 'LandingPageState'.
} => state.landingPage.update_form_error;

export const selectAttributesLoading = (state: State): boolean =>
  state?.landingPage?.current_state ===
  LandingPageCurrentState.LOADING_ATTRIBUTE_ACTION;

export const selectAttributes = (
  state: State,
): {
  [key: string]: string;
  // @ts-expect-error - TS2339 - Property 'attributes' does not exist on type 'LandingPageState'.
} => state?.landingPage?.attributes;

export const selectAttributesError = (
  state: State,
): {
  [key: string]: string;
  // @ts-expect-error - TS2339 - Property 'attributes_error' does not exist on type 'LandingPageState'.
} => state.landingPage.attributes_error;

export const selectLeadUpdateLoading = (state: State): boolean =>
  state?.landingPage?.current_state ===
  LandingPageCurrentState.LOADING_PAGE_UPDATE_LEAD_ACTION;

export const selectLeadUpdateResponse = (
  state: State,
): boolean | null | undefined =>
  // @ts-expect-error - TS2339 - Property 'update_lead' does not exist on type 'LandingPageState'.
  state.landingPage.update_lead;

export const selectLeadUpdateError = (
  state: State,
): {
  [key: string]: string;
  // @ts-expect-error - TS2339 - Property 'update_lead_error' does not exist on type 'LandingPageState'.
} => state.landingPage.update_lead_error;

export const selectEntityGroups = (
  state: State,
): {
  [key: string]: string;
  // @ts-expect-error - TS2339 - Property 'entity_groups' does not exist on type 'LandingPageState'.
} => state?.landingPage?.entity_groups;

export const selectEntityGroupsLoading = (state: State): boolean =>
  state?.landingPage?.current_state ===
  LandingPageCurrentState.LOADING_ENTITY_GROUP_ACTION;

export const selectEntityGroupsError = (
  state: State,
): {
  [key: string]: string;
  // @ts-expect-error - TS2339 - Property 'entity_groups_error' does not exist on type 'LandingPageState'.
} => state.landingPage.entity_groups_error;

export const selectCreateLandingPageSubDomain = (
  state: State,
): SubDomainDetail =>
  // @ts-expect-error - TS2339 - Property 'create_landing_page_subdomain' does not exist on type 'LandingPageState'.
  state?.landingPage?.create_landing_page_subdomain;

export const selectCreateLandingPageSubDomainError = (
  state: State,
): {
  [key: string]: string;
  // @ts-expect-error - TS2339 - Property 'create_landing_page_subdomain_error' does not exist on type 'LandingPageState'.
} => state?.landingPage?.create_landing_page_subdomain_error;

export const selectVerifyLandingPageSubDomain = (
  state: State,
): SubDomainDetail =>
  // @ts-expect-error - TS2339 - Property 'verify_subdomain' does not exist on type 'LandingPageState'.
  state?.landingPage?.verify_subdomain;

export const selectVerifyLandingPageSubDomainError = (
  state: State,
): {
  [key: string]: string;
  // @ts-expect-error - TS2339 - Property 'verify_subdomain_error' does not exist on type 'LandingPageState'.
} => state?.landingPage?.verify_subdomain_error;
export const selectCandidateSyncStatus = (
  state: State,
): string | null | undefined => state?.landingPage?.candidate_sync_status;

export const selectCandidateSyncStatusError = (
  state: State,
): {
  [key: string]: string;
  // @ts-expect-error - TS2339 - Property 'candidate_sync_status_error' does not exist on type 'LandingPageState'.
} => state.landingPage.candidate_sync_status_error;

export const selectSelectedFilterView = (state: State): LeadsFilter => {
  // @ts-expect-error - TS2339 - Property 'leads_filter' does not exist on type 'LandingPageState'.
  return state.landingPage.leads_filter?.selected_view;
};

export const selectLeadFiltersViewList = (
  state: State,
): LeadsCreateFilterResponse[] => {
  // @ts-expect-error - TS2339 - Property 'leads_filter_list' does not exist on type 'LandingPageState'.
  return state.landingPage?.leads_filter_list?.filters;
};

export const selectLeadFiltersViewSaveApply = (state: State): LeadForm[] => {
  // @ts-expect-error - TS2339 - Property 'leads_filter_save_apply' does not exist on type 'LandingPageState'.
  return state.landingPage?.leads_filter_save_apply;
};

export const selectLeadFiltersViewCount = (state: State): FilterViewCount => {
  // @ts-expect-error - TS2339 - Property 'leads_filter_count' does not exist on type 'LandingPageState'.
  return state.landingPage?.leads_filter_count;
};

export const selectLeadViewFilterActionResponse = (
  state: State,
): LeadFilterActionResponse => {
  // @ts-expect-error - TS2339 - Property 'leads_filter_action_response' does not exist on type 'LandingPageState'.
  return state.landingPage?.leads_filter_action_response;
};

export const selectDefaultPageTemplate = (state: State): BeFreeJson => {
  // @ts-expect-error - TS2339 - Property 'pages_default_template' does not exist on type 'LandingPageState'.
  return state.landingPage?.pages_default_template?.beefree_json;
};
